// extracted by mini-css-extract-plugin
export default {"picker":"ColorPicker_picker__4ibAp"};